// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"kununu-Kununu-wrapper-f9194b95"};